module.exports = __webpack_public_path__ + "static/media/bytt-no-9.4d83d715.mp3";